import React, { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import Dashboard from 'components/layouts/Dashboard';

import { useMe } from 'graphql/hooks/user';

const AdminRequired: FC = () => {
  const { isAdmin } = useMe();

  return isAdmin ? (
    <Dashboard>
      <Outlet />
    </Dashboard>
  ) : (
    <Navigate to="/" />
  );
};

export default AdminRequired;
